<template>
  <div class="custom-tooltip-container">
    <!-- 触发元素 -->
    <div ref="trigger" class="norTie" @mouseenter="showTooltip" @mouseleave="hideTooltip" @click.stop>
      {{ tit || '/' }}
    </div>

    <!-- 提示框 -->
    <div v-if="isShow" ref="tooltip" class="custom-tooltip" :style="{
      top: tooltipTop + 'px',
      left: tooltipLeft + 'px',
      opacity: isShow ? 1 : 0
    }">
      <div class="tooltip-content" @mouseenter.stop="preventHide" @mouseleave.stop="hideTooltip">
        {{ special ? '超期天数：' + special : tit }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tit: {
      type: String,
      default() {
        return ''
      }
    },
    //因为要求加上特殊提示
    special: {}
  },
  data() {
    return {
      isShow: false,
      tooltipTop: 0,
      tooltipLeft: 0,
      timer: null
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    // console.log(this.tit);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.timer) clearTimeout(this.timer);
  },
  methods: {
    showTooltip() {
      if (!this.tit) return;

      this.timer = setTimeout(() => {
        this.isShow = true;
        this.$nextTick(this.calculatePosition);
      }, 300);
    },

    hideTooltip() {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.isShow = false;
      }, 200);
    },

    preventHide() {
      if (this.timer) clearTimeout(this.timer);
    },

    // 修改位置计算逻辑
    calculatePosition() {
      if (!this.$refs.trigger || !this.$refs.tooltip) return;

      const triggerRect = this.$refs.trigger.getBoundingClientRect();
      const tooltipRect = this.$refs.tooltip.getBoundingClientRect();
      const windowWidth = window.innerWidth;

      // 始终在触发元素上方
      this.tooltipTop = triggerRect.top - tooltipRect.height - 10;

      // 水平居中
      let left = triggerRect.left + (triggerRect.width - tooltipRect.width) / 2;

      // 水平边界检查
      if (left < 10) {
        left = 10;
      } else if (left + tooltipRect.width > windowWidth - 10) {
        left = windowWidth - tooltipRect.width - 10;
      }

      this.tooltipLeft = left;
    },

    // 添加防抖的resize处理
    handleResize() {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.isShow) {
          this.calculatePosition();
        }
      }, 100);
    }
  }
}
</script>

<style scoped>
.norTie {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-tooltip {
  pointer-events: none;
  position: fixed;
  padding: 12px 14px;
  background-color: #fff;
  color: #333;
  border-radius: 4px;
  font-size: 13px;
  line-height: 24px;
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  max-width: 600px;
  white-space: normal;
  word-wrap: break-word;
  user-select: text;
}

/* 修改箭头为向下 */
.custom-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  /* 箭头在tooltip底部 */
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #fff;
  /* 箭头朝下 */
}

.tooltip-content {
  pointer-events: auto;
  /* 仅内容区域响应事件 */
  user-select: text;
}
</style>